import React from "react";
import GradeIcon from "@mui/icons-material/Grade";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { Box, IconButton } from "@mui/material";
import { useApiRequest } from "../../hooks/useApiRequest";
import { Model } from "../../types/model";
import { UserRole, UserRoles } from "../../types/userRole";
import { UserSession } from "../../types/user";

interface FavoriteModelButtonProps {
  isFavorite: boolean;
  modelGuid: string;
  user: UserSession | null;
  onSuccess: (model: Model) => void;
}

export const FavoriteModelButton: React.FC<FavoriteModelButtonProps> = ({
  isFavorite,
  modelGuid,
  user,
  onSuccess,
}) => {
  const { request: updateModelRequest, loading } = useApiRequest<Model>(false);

  const canFavoriteModel =
    loading === false &&
    user != null &&
    ([UserRole.OWNER, UserRole.ADMIN] as UserRoles[]).includes(user.userRole);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      {isFavorite === true ? (
        <IconButton
          color="warning"
          aria-label="Remove Favorite"
          sx={{ "&:disabled": { color: "#ed6c02" } }}
          disabled={!canFavoriteModel || loading}
          onClick={(e) => {
            e.stopPropagation();
            updateModelRequest(
              `company/models/${modelGuid}/favorite`,
              {
                method: "POST",
                data: { isFavorite: false },
              },
              { onSuccess }
            );
          }}
        >
          <GradeIcon />
        </IconButton>
      ) : (
        <IconButton
          color="warning"
          aria-label="Favorite"
          sx={{ "&:disabled": { color: "#ed6c02" } }}
          disabled={!canFavoriteModel || loading}
          onClick={(e) => {
            e.stopPropagation();
            updateModelRequest(
              `company/models/${modelGuid}/favorite`,
              {
                method: "POST",
                data: { isFavorite: true },
              },
              { onSuccess }
            );
          }}
        >
          <StarOutlineIcon />
        </IconButton>
      )}
    </Box>
  );
};
